import Scanner from "../components/Scanner.svelte";
import Search from "../components/Search.svelte";

export default {
    "/": Scanner,
    "/search/": Search,
    // "/todo/:id": ToDo,
};